import React from 'react';
import SidePanel from 'components/side-panel/SidePanel';
import { NavCloseIcon } from 'assets/icons';
import { logAnalyticEvent } from 'utils/analytics';
import { SettingsCleverTapEvents } from '../events';

interface CommissionCalculationExampleProps {
  isOpen: boolean;
  onClose: () => void;
}

const CommissionCalculationExample: React.FC<CommissionCalculationExampleProps> = ({ isOpen, onClose }) => {
  logAnalyticEvent(SettingsCleverTapEvents.webSettingsCommissionCalculationExampleView);
  return (
    <SidePanel isOpen={isOpen} onClose={onClose} shouldAnimate={true}>
      <div className="flex h-full w-[375px] flex-col">
        <div className="flex items-center p-4">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <NavCloseIcon className="h-4 w-4" />
          </button>
          <h2 className="ml-2 text-[17px] font-semibold text-primaryText">Commission calculation</h2>
        </div>

        <div className="flex-1 overflow-y-auto py-6">
          <div className="rounded-lg bg-white">
            <h3 className="mb-2 text-center text-lg font-medium">Example job</h3>
            <p className="text-center text-sm text-accentText">JOB -123456</p>

            <div className="mt-6 space-y-4 text-sbase font-semibold text-primaryText">
              {/* Line Item */}
              <div className="flex justify-between px-4">
                <div>
                  <p>Sample line item</p>
                  <p className="text-[13px] text-accentText">(2 x $160.00)</p>
                </div>
                <p>$320.00</p>
              </div>

              {/* Discount */}
              <div className="mx-4 flex justify-between border-t border-gray-200 pt-6">
                <p>Discount</p>
                <div className="flex items-center gap-4">
                  <p className="text-accentText">$20</p>
                  <p className="text-primaryText">- $20.00</p>
                </div>
              </div>

              {/* Subtotal */}
              <div className="flex justify-between bg-highlightGray px-4 py-3">
                <p>Subtotal</p>
                <p>$300.00</p>
              </div>

              {/* Additional Fees */}
              <div className="space-y-4 px-4">
                <div className="flex justify-between">
                  <p>Tax</p>
                  <p>$50.00</p>
                </div>
                <div className="flex justify-between">
                  <p>Tip</p>
                  <p>$50.00</p>
                </div>
                <div className="flex justify-between">
                  <p>Service fee</p>
                  <p>$100.00</p>
                </div>
              </div>

              {/* Total */}
              <div className="flex justify-between bg-highlightGray px-4 py-3">
                <p>Total</p>
                <p>$500.00</p>
              </div>

              {/* Cost & Profit */}
              <div className="space-y-4 px-4">
                <div className="flex justify-between">
                  <p>Cost</p>
                  <p>$100.00</p>
                </div>
                <div className="flex justify-between">
                  <p>Profit</p>
                  <p>$200.00</p>
                </div>
              </div>

              {/* Commission Details */}
              <div className="mx-4 space-y-2 border-t border-gray-200 pt-4">
                <div className="flex justify-between">
                  <p>Rate</p>
                  <div className="text-right">
                    <p>20%</p>
                    <p className="text-[13px] text-accentText">(100.00% split)</p>
                  </div>
                </div>
                <div className="flex justify-between">
                  <p>Commission on</p>
                  <div className="text-right">
                    <p>$500.00</p>
                    <p className="text-[13px] text-accentText">(total)</p>
                  </div>
                </div>
              </div>

              {/* Final Commission */}
              <div className="mx-4 flex justify-between border-t border-gray-200 pt-4 text-[17px]">
                <p className="font-bold">Commission</p>
                <div className="text-right">
                  <p className="font-bold">$100.00</p>
                  <p className="text-[13px] text-accentText">(20% of $500.00)</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidePanel>
  );
};

export default CommissionCalculationExample;
